import { render, staticRenderFns } from "./PersonalVaccine.vue?vue&type=template&id=8d591a24&"
import script from "./PersonalVaccine.vue?vue&type=script&lang=js&"
export * from "./PersonalVaccine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports